module.exports = __webpack_public_path__ + "img/202.4fedd2fb.jpg";